import { AlertConditionType, addAlertRequestType, alertResponseType } from '../types';
import { store } from '../../../store';
import { userModelType } from '../../../features/auth/types';
import { axiosWithToken } from '../../../utils/axios';
import { AxiosError } from 'axios';

export async function postAlert(data: addAlertRequestType): Promise<false | alertResponseType> {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.post(`/clients/${client_id}/alerts/`, {
      data,
      isToken: true,
    });

    return res.data;
  } catch (error) {
    return false;
  }
}

export const getAlertByClients = async () => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.get(`/clients/${client_id}/alerts/`);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getAlertByAlertID = async (id: string) => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.get(`/clients/${client_id}/alerts/${id}/`);
    return res.data as addAlertRequestType;
  } catch (error) {
    return false;
  }
};

export const deleteAlertById = async (id: string) => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.delete(`/clients/${client_id}/alerts/${id}/`);
    return res.data as addAlertRequestType;
  } catch (error) {
    return false;
  }
};

export const putAlertById = async (
  id: string,
  data: addAlertRequestType,
): Promise<false | alertResponseType> => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.put(`/clients/${client_id}/alerts/${id}/`, {
      data,
      isToken: true,
    });
    return res.data as alertResponseType;
  } catch (error) {
    return false;
  }
};

export const postAlertConditions = async (alertId: string, alertConditionList: AlertConditionType[]) => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.post(`clients/${client_id}/alerts/${alertId}/alert_condition/`, {
      data: alertConditionList,
      isToken: true,
    });
    return res.data as alertResponseType;
  } catch (error) {
    return error as AxiosError;
  }
};

export const putAlertConditions = async (alertId: string, alertConditionList: AlertConditionType[]) => {
  const user = (await store.getItem('user')) as userModelType;
  const client_id = user.client.id;
  try {
    const res = await axiosWithToken.put(`/clients/${client_id}/alerts/${alertId}/alert_condition/`, {
      data:alertConditionList,
      isToken: true,
    });
    return res.data as alertResponseType;
  } catch (error) {
    return error as AxiosError;
  }
};
